export const urls = {
  GET_VRSTE_USLUGA: 'Combo/vrati_vrste_usluga_combo',
  GET_DELOVI_COMBO: 'Combo/vrati_delove_combo',
  VRATI_STAVKE_ZA_RN:
    'DokRNServisniStavkeTroskovi/vrati_stavke_troskovi_za_dok_rn_servisni',
  INSERT_STAVKE:
    'DokRNServisniStavkeTroskovi/unos_stavke_troskovi_za_dok_rn_servisni',
  UPDATE_STAVKE:
    'DokRNServisniStavkeTroskovi/izmena_stavke_troskovi_za_dok_rn_servisni',
  DELETE_STAVKE:
    'DokRNServisniStavkeTroskovi/brisanje_stavke_troskovi_za_dok_rn_servisni',
  GET_VRSTE_USLUGE:
    'DokRNServisniStavkeZaposleni/dok_rn_servisni_vrati_vrste_usluge_stavke_troskovi',
  INSERT_DOKUMENTA: 'Dokumenta/unos_dokumenta',
  GET_DOKUMENT: 'Dokumenta/vrati_dokumenta_objekta',
  DELETE_DOKUMENT: 'Dokumenta/brisanje_dokumenta_objekta',
};
